export const LOAD_CLASIFICACION_MOVIMIENTOS = 'LOAD_CLASIFICACION_MOVIMIENTOS';
export const SET_CLASIFICACION_MOVIMIENTOS = 'SET_CLASIFICACION_MOVIMIENTOS';
export const SAVE_CLASIFICACION_MOVIMIENTO = 'SAVE_CLASIFICACION_MOVIMIENTO';
export const SAVED_CLASIFICACION_MOVIMIENTO = 'SAVED_CLASIFICACION_MOVIMIENTO';

export const loadClasificacionMovimientos = () => ({
    type: LOAD_CLASIFICACION_MOVIMIENTOS,
});

export const setClasificacionMovimientos = (clasificaciones) => ({
    type: SET_CLASIFICACION_MOVIMIENTOS,
    clasificaciones,
});

export const saveClasificacionMovimiento = (clasificacion) => ({
    type: SAVE_CLASIFICACION_MOVIMIENTO,
    clasificacion,
});

export const savedClasificacionMovimiento = (clasificacion) => ({
    type: SAVED_CLASIFICACION_MOVIMIENTO,
    clasificacion,
});

const initialState = {
    clasificaciones: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
    case SAVED_CLASIFICACION_MOVIMIENTO: {
        const { clasificacion } = action;
        const index = state.clasificaciones.findIndex((item) => item.id === clasificacion.id);
        if (index === -1) {
            return { ...state, clasificaciones: state.clasificaciones.concat(clasificacion) };
        }
        const updated = state.clasificaciones
            .slice(0, index)
            .concat([clasificacion])
            .concat(state.clasificaciones.slice(index + 1));
        return { ...state, clasificaciones: updated };
    }
    case SET_CLASIFICACION_MOVIMIENTOS: {
        return { ...state, clasificaciones: action.clasificaciones };
    }
    default:
        return state;
    }
};
